import React from 'react';
import { useState, useEffect} from "react";
import { connect } from 'react-redux';
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import { useHistory } from 'react-router-dom';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { AuthenticationResult } from '@azure/msal-common';
var Config: any = require('../../Config.json');

export const AzureADRedirectLogin = (props) => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [userInfo, setUserInfo] = useState(null);
    const [redirectInitiated, setRedirectInitiated] = useState(false);
    const [signindisallowed, setSignindisallowed] = useState(false);
    const [signinError, setSigninError] = useState(false);
    const [signinDataError, setSigninDataError] = useState(false);
    const [signinDataErrorMsg, setSigninDataErrorMsg] = useState('');
    const loginRequest = {
        scopes: ["api://" + Config.AzurereApiclientId + "/access_rc","email"],

    };

    const history = useHistory();
    useEffect(() => {
        setSigninError(false);
        setSigninDataError(false);
        setSignindisallowed(false);
            instance
                .handleRedirectPromise()
                .then((tokenResponse: AuthenticationResult) => {
                    if (tokenResponse !== null && !redirectInitiated) {
                        setRedirectInitiated(true);
                        if (tokenResponse.idTokenClaims != undefined && tokenResponse.idTokenClaims != null && tokenResponse.idTokenClaims['given_name'] != undefined && tokenResponse.idTokenClaims['given_name'] != "") {
                            sessionStorage.setItem('AZUName', tokenResponse.idTokenClaims['given_name']);
                        }
                        let accessToken = tokenResponse.accessToken;
                        sessionStorage.setItem('JWTToken', accessToken);
                        var url = Config.ApiBaseUrl + '/api/AuthUser/ValidateAzureADUser';
                        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        fetch(request)
                            .then(RCUtils.handleOktaError)
                            .then(response => response.json() as Promise<server.UserLoginDetails>)
                            .then(data => {
                                if (data.Errmsg == null || data.Errmsg == "") {
                                    var preloader = document.getElementById("preloader");
                                    preloader.classList.add("hidden");
                                    var userDetailInfo = JSON.parse(JSON.stringify(data));
                                    if (userDetailInfo != null && userDetailInfo.User != null && userDetailInfo.User != undefined) {
                                        sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
                                        localStorage.setItem('login_status', 'logged_in' + '&' + JSON.stringify(userDetailInfo.User.UserName));
                                        sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

                                        var userInfo = JSON.stringify({
                                            'Username': userDetailInfo.User.UserName, 'IsAccountLocked': userDetailInfo.IsAccountLocked, 'IsLoggedIn': true,
                                            'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
                                            'LoginAttempts': userDetailInfo.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd,
                                            'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
                                            'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
                                            'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState,
                                            'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'AzureSignInOverrideOption': userDetailInfo.User.AzureSignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide,
                                            'GravityVectorPrecision': userDetailInfo.User.GravityVectorPrecision
                                        });
                                        sessionStorage.setItem('UserInfo', userInfo);
                                        setUserInfo(userInfo);
                                        if (userDetailInfo.User.Customer.AzureSignInOption == "D") {
                                            
                                            setSignindisallowed(true);
                                            setTimeout(() => {
                                                 if (localStorage.length > 0) {
                                                        localStorage.clear();
                                                        }
                                                 if (sessionStorage.length > 0) {
                                                        sessionStorage.clear();
                                                        }

                                                $('#globalLoader').hide();
                                            }, 800);
                                            PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft.");
                                            return;
                                        }
                                        else if (userDetailInfo.User.AzureSignInOverrideOption == "D") {
                                                    setSignindisallowed(true);
                                           
                                            setTimeout(() => {
                                                 if (localStorage.length > 0) {
                                                        localStorage.clear();
                                                        }
                                                 if (sessionStorage.length > 0) {
                                                        sessionStorage.clear();
                                                        }

                                                $('#globalLoader').hide();
                                            }, 800);
                                            PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft.");
                                            return;
                                        } else {
                                            sessionStorage.setItem('AZRD', 'true');
                                            history.push('/home');
                                        }
                                    } else {
                                        var loader = document.getElementById("preloader");
                                        loader.classList.add("hidden");
                                        PopupWindow.showErrorMessage("Login", "User data not match with Maritime platform data. Please contact ORBCOMM support team for further information.");
                                    }
                                }
                                else {
                                    setSigninDataError(true);
                                    setSigninDataErrorMsg(data.Errmsg);
                                    var loader = document.getElementById("preloader");
                                    loader.classList.add("hidden");
                                    PopupWindow.showErrorMessage("Login", data.Errmsg);
                                }

                            });
                    }
                })
                .catch(error => {
                    setSigninError(true);
                    var loader = document.getElementById("preloader");
                        loader.classList.add("hidden");
                        console.error(error);
                    PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
                });
        if (sessionStorage.getItem('azureInit') == null) {
            sessionStorage.setItem('azureInit', 'true')
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
                setSigninError(true);
                PopupWindow.showErrorMessage("Login", " 'Sign in with Microsoft' is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.");
            });;
        }
    }, [redirectInitiated]);
 const RedirectToRC = () => {      
        window.location.href = "/";
    };

   
   
    return (
        
        <>
            <div className="SignOutTextContainer">
                <div>
                    {isAuthenticated && !signindisallowed && !signinDataError ?
                            
                        <div> Loading Maritime platform..... </div>
                           
                       
                   : ''}
                </div>
                <div >
                         {  isAuthenticated && signindisallowed   ?  
                        <>
                        <div>
                                <div> 'Sign in with Microsoft' has been disallowed by your administrator. Please sign in to Maritime platform without using Microsoft. You will now be redirected to the Maritime platform Sign-In page </div>
                           <button type="button" className="btn btn-primary mt-3" onClick={RedirectToRC}> Sign In</button>
                        </div>
                         </>  
                        
                    : ''}
                </div>
                <div>
                    {isAuthenticated && !signindisallowed && signinDataError ?
                      

                        <div> {signinDataErrorMsg} </div>
                         
                       
                     : ''}
                </div>
                <div>
                    {!isAuthenticated && signinError ? 
                       
                           
                        <div>-Sign in with Microsoft- is not available for this account. Please contact your local Maritime platform administrator or ORBCOMM Customer Care for assistance.</div>
                           
                    : ''}
                </div>
            </div>
           
            <br />
            <br />
            {props.children}
        </>
    );
};
export default connect()(AzureADRedirectLogin);
